import { defineComponent as n, useCssModule as t, resolveComponent as l, openBlock as a, createElementBlock as c, normalizeClass as o, createElementVNode as e, createVNode as m, renderSlot as i, toDisplayString as p } from "vue";
import d from "../icon/comps/error-stroke.vue.mjs";
import f from "./styles/CdrFormError.module.scss.mjs";
import u from "../../../_virtual/_plugin-vue_export-helper.mjs";
const C = n({
  name: "CdrFormError",
  components: {
    IconErrorStroke: d
  },
  props: {
    error: [Boolean, String]
  },
  setup() {
    return {
      style: t(),
      baseClass: "cdr-form-error",
      iconClass: "cdr-form-error__icon"
    };
  }
});
function _(r, $, k, E, S, B) {
  const s = l("icon-error-stroke");
  return a(), c("div", {
    class: o(r.style[r.baseClass]),
    role: "status"
  }, [e("span", {
    class: o(r.style[r.iconClass])
  }, [m(s, {
    size: "small",
    "inherit-color": ""
  })], 2), i(r.$slots, "error", {}, () => [e("span", null, p(r.error), 1)])], 2);
}
const y = {
  $style: f
}, v = /* @__PURE__ */ u(C, [["render", _], ["__cssModules", y]]);
export {
  v as default
};
